import type { Dimensions } from "../types/Dimensions";

export default (file: File): Promise<Dimensions> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result as string;

      img.onload = () => {
        if (img.height === 0 || img.width === 0) {
          reject("Invalid image size");
        }

        resolve({
          heigth: img.height,
          width: img.width,
        });
      };
    };
  });
}
